<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" right="iconadd" @rightClick="onAddStudent" />

    <van-checkbox-group v-model="selectItemList" class="listRect">
      <div v-for="item in list" :key="item.studentId" class="line">
        <van-row>
          <van-col span="2" class="selectRect"><van-checkbox :key="item.studentId" :name="item.studentId" class="icon" /></van-col>
          <van-col span="20">
            <div class="name">姓:{{ item.lastName }} 名:{{ item.firstName }}</div>
            <div class="body">生日:{{ formatDate(item.birthday,"yyyy-MM-dd") }} 邮箱:{{ item.email }}</div>
          </van-col>
          <van-col span="2" class="edit"><i class="iconfont iconguanli rightGoto" @click="onEdit(item.studentId)" /></van-col>
        </van-row>
      </div>
      <div class="emptyRect" />
    </van-checkbox-group>
    <div class="downButton">
      <van-button v-if="!orderId" type="info" square @click="onAddStudent">新增学员</van-button>
      <van-button v-if="orderId" :loading="addStudentLoading" :disabled="selectItemList.length != needNum && needNum > 0" type="info" square @click="onSelectStudent">({{ selectItemList.length }}/{{ needNum }})补充学员信息</van-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey, formatDate, MyNotify } from '@/utils/base'
import { Button, Checkbox, CheckboxGroup } from 'vant'
export default {
  components: {
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    TopBar
  },
  data() {
    return {
      title: '学员信息管理',
      backurl: '/users/index',
      list: undefined,
      orderId: undefined,
      selectItemList: [],
      needNum: 0,
      addStudentLoading: false
    }
  },
  created() {
    initPage()
    this.orderId = getUrlKey('orderId')
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    if (this.orderId === 'null' || this.orderId === 'undefined') {
      this.orderId = undefined
    }
    if (this.orderId) {
      this.backurl = '/store/orderInfo/' + this.orderId
    }
    this.getOrderNeedNum()
    this.getList()
  },
  methods: {
    formatDate,
    getOrderNeedNum() {
      if (!this.orderId) {
        return
      }
      request({
        url: '/Store/getOrderCommodityNum',
        method: 'post',
        data: {
          orderId: this.orderId
        }
      }).then(Response => {
        if (Response.success) {
          this.needNum = Response.data
        } else {
          this.needNum = 0
        }
      })
    },
    getList() {
      request({
        url: '/Store/getStudentModelInfoList',
        method: 'post'
      }).then(Response => {
        if (Response.success) {
          this.list = Response.data
        }
      })
    },
    onAddStudent() {
      this.$router.replace('/store/studentEdit/0?orderId=' + this.orderId)
    },
    onEdit(id) {
      this.$router.replace('/store/studentEdit/' + id + '?orderId=' + this.orderId)
    },
    onSelectStudent() {
      this.addStudentLoading = true
      request({
        url: '/Store/ChangeOrderStudent',
        method: 'post',
        data: {
          orderId: this.orderId,
          studentList: this.selectItemList
        }
      }).then(Response => {
        if (Response.success) {
          MyNotify('success', '补充学员信息成功，请再次核对信息是否正确', 5000)
          this.$router.replace(this.backurl)
        }
      })
    }
  }
}
</script>
<style scoped>
.listRect{

}
.line{
  background: #fff;
  border-top: 1px solid #dadada;
  border-bottom: 1px solid #dadada;
    padding: 1em;
    height: 3em;
    margin: 0.5em 0;

}
.line .edit{
    line-height: 3em;
}
.line .selectRect{
    position: relative;
    height: 3em;
}
.line .icon{
    position: absolute;
    top:50%;
    margin-top:-10px;
}
.line .name{
  font-weight: 700;
}
.line .body{
  font-size: 0.7em;
  margin-top: 0.3em;
  color: #999;
}
.downButton{
    position:fixed;
    z-index: 2;
    left: 0;
    bottom: 0;
    width: 100%;
}
.downButton button{
    width: 100%;
}
.emptyRect{
    height: 3em;
}

</style>
